module.exports = __webpack_public_path__ + "static/media/about.c6ed81dd.svg";